import React from 'react'
import { useParams } from 'react-router-dom';
import { useGetBookByIdQuery, useEditBookMutation } from '../features/api/apiSlice';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';


export default function EditBook() {
    const { bookId } = useParams();
    const { data: book, isLoading, isError } = useGetBookByIdQuery(bookId);
    console.log(book);
    const [editBook] = useEditBookMutation();
    // const { name: initialName, thumbnail: initialThumbnail, initialPrice, initialAuthor, initialRating, initialFeatured } = book;

    const [bookName, setBookName] = useState('');
    const [author, setAuthor] = useState('');
    const [thumbnail, setThumbnail] = useState('');
    const [price, setPrice] = useState('');
    const [rating, setRating] = useState('');
    const [featured, setFeatured] = useState();
    useEffect(() => {
        if (book) {
            setBookName(book.name);
            setAuthor(book.author);
            setThumbnail(book.thumbnail);
            setPrice(book.price);
            setRating(book.rating);
            setFeatured(book.featured);
        }
    }, [book]);
    const navigate = useNavigate();
    const handleSubmit = (event) => {
        event.preventDefault();
        const bookData = {
            name: bookName,
            author,
            thumbnail,
            price,
            rating,
            featured,
            id: Number(bookId),
        };
        console.log("Editing this book witht his value=>", bookData);
        editBook({ id: bookId, bookData })
            .then(() => {
                // reset form after successful submission
                setBookName('');
                setAuthor('');
                setThumbnail('');
                setPrice('');
                setRating('');
                setFeatured();
                navigate("/");

            })
            .catch((err) => console.error(err));;
    };


    return (
        <div class="container">
            <div class="p-8 overflow-hidden bg-white shadow-cardShadow rounded-md max-w-xl mx-auto">
                <h4 class="mb-8 text-xl font-bold text-center">Edit Book</h4>
                <form class="book-form" onSubmit={handleSubmit}>
                    <div class="space-y-2">
                        <label for="lws-bookName">Book Name</label>
                        <input required class="text-input" type="text" id="lws-bookName" name="name"

                            value={bookName}
                            onChange={(e) => setBookName(e.target.value)}
                        />
                    </div>

                    <div class="space-y-2">
                        <label for="lws-author">Author</label>
                        <input required class="text-input" type="text" id="lws-author" name="author"
                            value={author}
                            onChange={(e) => setAuthor(e.target.value)}
                        />
                    </div>

                    <div class="space-y-2">
                        <label for="lws-thumbnail">Image Url</label>
                        <input required class="text-input" type="text" id="lws-thumbnail" name="thumbnail"
                            value={thumbnail}
                            onChange={(e) => setThumbnail(e.target.value)}
                        />
                    </div>

                    <div class="grid grid-cols-2 gap-8 pb-4">
                        <div class="space-y-2">
                            <label for="lws-price">Price</label>
                            <input required class="text-input" type="number" id="lws-price" name="price"
                                value={price}
                                onChange={(e) => setPrice(e.target.value)}
                            />
                        </div>

                        <div class="space-y-2">
                            <label for="lws-rating">Rating</label>
                            <input required class="text-input" type="number" id="lws-rating" name="rating" min="1"
                                max="5"
                                value={rating}
                                onChange={(e) => setRating(e.target.value)}
                            />
                        </div>
                    </div>

                    <div class="flex items-center">
                        <input id="lws-featured" type="checkbox" name="featured" class="w-4 h-4" checked={featured}
                            onChange={(e) => setFeatured(e.target.checked)}
                        />
                        <label for="lws-featured" class="ml-2 text-sm"> This is a featured book </label>
                    </div>

                    <button type="submit" class="submit" id="lws-submit">Edit Book</button>
                </form>
            </div>
        </div>
    )
}
